"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSessionsPath = exports.buildSessionPath = exports.buildTracesPath = exports.buildTracePath = exports.buildScoresPath = exports.buildPromptsPath = exports.buildProjectSettingsPath = exports.buildProjectMembersPath = exports.buildPlaygroundPath = exports.buildMonitorsPath = exports.buildModelsPath = exports.buildExperimentPath = exports.buildExperimentsPath = exports.buildEvalsPath = exports.buildDatasetsPath = exports.buildDashboardWidgetPath = exports.buildDashboardWidgetsPath = exports.buildDashboardsPath = exports.buildProjectPath = exports.appendProductPathQuery = void 0;
exports.parseSavedViewFromURL = parseSavedViewFromURL;
const table_view_presets_1 = require("../domain/table-view-presets");
const filterQueryEncoding_1 = require("../features/filters/filterQueryEncoding");
const dateRanges_1 = require("./dateRanges");
function parseSavedViewFromURL(currentUrl, isV4Enabled) {
    let parsedUrl;
    try {
        parsedUrl = new URL(currentUrl, "https://langfuse.local");
    }
    catch {
        return undefined;
    }
    const pathSegments = parsedUrl.pathname.split("/").filter(Boolean);
    const projectSegmentIndex = pathSegments.indexOf("project");
    const section = pathSegments[projectSegmentIndex + 2];
    const detailId = pathSegments[projectSegmentIndex + 3];
    const viewId = parsedUrl.searchParams.get("viewId");
    if (projectSegmentIndex === -1 || !section || !viewId) {
        return undefined;
    }
    if (section === "traces" && !detailId) {
        return {
            viewId,
            tableName: isV4Enabled
                ? table_view_presets_1.TableViewPresetTableName.ObservationsEvents
                : table_view_presets_1.TableViewPresetTableName.Traces,
        };
    }
    if (section === "observations" && !detailId) {
        return {
            viewId,
            tableName: isV4Enabled
                ? table_view_presets_1.TableViewPresetTableName.ObservationsEvents
                : table_view_presets_1.TableViewPresetTableName.Observations,
        };
    }
    if (section === "sessions") {
        return {
            viewId,
            tableName: detailId
                ? table_view_presets_1.TableViewPresetTableName.SessionDetail
                : table_view_presets_1.TableViewPresetTableName.Sessions,
        };
    }
    if (section === "datasets" && !detailId) {
        return { viewId, tableName: table_view_presets_1.TableViewPresetTableName.Datasets };
    }
    if (section === "scores" && !detailId) {
        return { viewId, tableName: table_view_presets_1.TableViewPresetTableName.Scores };
    }
    if (section === "experiments" && detailId === "results") {
        return { viewId, tableName: table_view_presets_1.TableViewPresetTableName.ExperimentItems };
    }
    if (section === "experiments" && !detailId) {
        return { viewId, tableName: table_view_presets_1.TableViewPresetTableName.Experiments };
    }
    return undefined;
}
const appendProductPathQuery = (path, query) => {
    const searchParams = new URLSearchParams();
    Object.entries(query).forEach(([key, value]) => {
        if (!value) {
            return;
        }
        if (Array.isArray(value)) {
            value.forEach((item) => {
                if (item) {
                    searchParams.append(key, item);
                }
            });
        }
        else {
            searchParams.set(key, value);
        }
    });
    const queryString = searchParams.toString();
    return queryString ? `${path}?${queryString}` : path;
};
exports.appendProductPathQuery = appendProductPathQuery;
const buildProjectPath = (params) => `/project/${encodeURIComponent(params.projectId)}`;
exports.buildProjectPath = buildProjectPath;
const buildDashboardsPath = (params) => `${(0, exports.buildProjectPath)(params)}/dashboards`;
exports.buildDashboardsPath = buildDashboardsPath;
const buildDashboardWidgetsPath = (params) => `${(0, exports.buildProjectPath)(params)}/widgets`;
exports.buildDashboardWidgetsPath = buildDashboardWidgetsPath;
const buildDashboardWidgetPath = (params) => `${(0, exports.buildDashboardWidgetsPath)(params)}/${encodeURIComponent(params.widgetId)}`;
exports.buildDashboardWidgetPath = buildDashboardWidgetPath;
const buildDatasetsPath = (params) => (0, exports.appendProductPathQuery)(`${(0, exports.buildProjectPath)(params)}/datasets`, {
    folder: params.folder,
});
exports.buildDatasetsPath = buildDatasetsPath;
const buildEvalsPath = (params) => `${(0, exports.buildProjectPath)(params)}/evals`;
exports.buildEvalsPath = buildEvalsPath;
const buildExperimentsPath = (params) => `${(0, exports.buildProjectPath)(params)}/experiments`;
exports.buildExperimentsPath = buildExperimentsPath;
const buildExperimentPath = (params) => (0, exports.appendProductPathQuery)(`${(0, exports.buildExperimentsPath)(params)}/results`, {
    baseline: params.experimentId,
});
exports.buildExperimentPath = buildExperimentPath;
const buildModelsPath = (params) => `${(0, exports.buildProjectPath)(params)}/models`;
exports.buildModelsPath = buildModelsPath;
const buildMonitorsPath = (params) => `${(0, exports.buildProjectPath)(params)}/alerts`;
exports.buildMonitorsPath = buildMonitorsPath;
const buildPlaygroundPath = (params) => `${(0, exports.buildProjectPath)(params)}/playground`;
exports.buildPlaygroundPath = buildPlaygroundPath;
const buildProjectMembersPath = (params) => `${(0, exports.buildProjectPath)(params)}/settings/members`;
exports.buildProjectMembersPath = buildProjectMembersPath;
const buildProjectSettingsPath = (params) => params.page && params.page !== "index"
    ? `${(0, exports.buildProjectPath)(params)}/settings/${params.page}`
    : `${(0, exports.buildProjectPath)(params)}/settings`;
exports.buildProjectSettingsPath = buildProjectSettingsPath;
const buildPromptsPath = (params) => (0, exports.appendProductPathQuery)(`${(0, exports.buildProjectPath)(params)}/prompts`, {
    folder: params.folder,
});
exports.buildPromptsPath = buildPromptsPath;
const buildScoresPath = (params) => `${(0, exports.buildProjectPath)(params)}/scores`;
exports.buildScoresPath = buildScoresPath;
const buildTracePath = (params) => (0, exports.appendProductPathQuery)(`${(0, exports.buildProjectPath)(params)}/traces/${encodeURIComponent(params.traceId)}`, {
    observation: params.observationId,
    timestamp: params.timestamp instanceof Date
        ? params.timestamp.toISOString()
        : decodeURIComponentSafely(params.timestamp),
});
exports.buildTracePath = buildTracePath;
const decodeURIComponentSafely = (value) => {
    if (!value) {
        return undefined;
    }
    try {
        return decodeURIComponent(value);
    }
    catch {
        return value;
    }
};
const buildTracesPath = (params) => (0, exports.appendProductPathQuery)(`${(0, exports.buildProjectPath)(params)}/traces`, params.params
    ? {
        ...getTracesPathQuery(params.params, Boolean(params.isV4Enabled)),
        ...params.query,
    }
    : (params.query ?? {}));
exports.buildTracesPath = buildTracesPath;
function getTracesPathQuery(params, isV4Enabled) {
    const filters = params.filters
        ? getTracesFilterState(params.filters, isV4Enabled)
        : [];
    const orderBy = params.orderBy
        ? normalizeTracesOrderBy(params.orderBy, isV4Enabled)
        : undefined;
    return {
        dateRange: params.timeRange
            ? getDateRangeQueryValue(params.timeRange)
            : undefined,
        filter: filters.length > 0 ? (0, filterQueryEncoding_1.encodeFiltersGeneric)(filters) : undefined,
        orderBy: orderBy
            ? `column-${orderBy.column}_order-${orderBy.order}`
            : undefined,
        search: params.search?.query,
        searchType: params.search?.type,
    };
}
function getDateRangeQueryValue(timeRange) {
    if ("preset" in timeRange) {
        return (0, dateRanges_1.rangeToString)({ range: timeRange.preset });
    }
    return (0, dateRanges_1.rangeToString)({
        from: new Date(timeRange.from),
        to: new Date(timeRange.to),
    });
}
function getTracesFilterState(filters, isV4Enabled) {
    const filterState = [];
    const addStringOptionsFilter = (column, value) => {
        if (!value || value.length === 0) {
            return;
        }
        filterState.push({
            column,
            operator: "any of",
            type: "stringOptions",
            value,
        });
    };
    const addArrayOptionsFilter = (column, value) => {
        if (!value || value.length === 0) {
            return;
        }
        filterState.push({
            column,
            operator: "any of",
            type: "arrayOptions",
            value,
        });
    };
    addStringOptionsFilter("environment", filters.environment);
    addStringOptionsFilter("level", filters.level);
    if (!isV4Enabled) {
        addStringOptionsFilter("sessionId", filters.sessionId);
    }
    addStringOptionsFilter("traceName", filters.traceName);
    addStringOptionsFilter("userId", filters.userId);
    addArrayOptionsFilter(isV4Enabled ? "tags" : "traceTags", filters.tags);
    if (!isV4Enabled && filters.bookmarked !== undefined) {
        filterState.push({
            column: "bookmarked",
            operator: "=",
            type: "boolean",
            value: filters.bookmarked,
        });
    }
    if (filters.traceId) {
        filterState.push({
            column: isV4Enabled ? "traceId" : "id",
            operator: "=",
            type: "string",
            value: filters.traceId,
        });
    }
    if (filters.version) {
        if (isV4Enabled) {
            filterState.push({
                column: "version",
                operator: "any of",
                type: "stringOptions",
                value: [filters.version],
            });
        }
        else {
            filterState.push({
                column: "version",
                operator: "=",
                type: "string",
                value: filters.version,
            });
        }
    }
    for (const metadataFilter of filters.metadata ?? []) {
        filterState.push({
            column: "metadata",
            key: metadataFilter.key,
            operator: "=",
            type: "stringObject",
            value: metadataFilter.value,
        });
    }
    return filterState;
}
function normalizeTracesOrderBy(orderBy, isV4Enabled) {
    if (orderBy.column === "timestamp" || orderBy.column === "startTime") {
        return {
            column: isV4Enabled ? "startTime" : "timestamp",
            order: orderBy.order,
        };
    }
    return orderBy;
}
const buildSessionPath = (params) => `${(0, exports.buildProjectPath)(params)}/sessions/${encodeURIComponent(params.sessionId)}`;
exports.buildSessionPath = buildSessionPath;
const buildSessionsPath = (params) => `${(0, exports.buildProjectPath)(params)}/sessions`;
exports.buildSessionsPath = buildSessionsPath;
